let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("geKrL")).then(() => parcelRequire('erYks'));